import React from "react";

export const ALLOWANCE_TYPES = [["", "Simplified"], ["1", "VAT"], ["2", "Purchase"], ["3", "Credit Notes"], ["4", "Debit Notes"]];
export const initialUnlimitedFlags = (plan) => Object.fromEntries(
  ["", "shopify_"].flatMap(prefix => ALLOWANCE_TYPES.map(([suffix]) => {
    const field = `${prefix}unlimited_invoices${suffix}`;
    return [field, Number(plan?.[field] ?? (Number(plan?.[`${prefix}max_invoices${suffix}`]) >= 10000 ? 1 : 0))];
  }))
);

export default function MembershipAllowances({ formik }) {
  return <>{["", "shopify_"].map(prefix => <React.Fragment key={prefix}>
    <tr><th>{prefix ? "Shopify Invoice Type" : "MyFatoorah / Website / WordPress Invoice Type"}</th><th>Limited Number / Fair Usage</th><th>Unlimited</th></tr>
    {ALLOWANCE_TYPES.map(([suffix, label]) => {
      const number = `${prefix}max_invoices${suffix}`;
      const unlimited = `${prefix}unlimited_invoices${suffix}`;
      const checked = Number(formik.values[unlimited]) === 1;
      return <tr key={number}>
        <td>{label}</td>
        <td><label className="membership-allowance-label" htmlFor={number}>{checked ? "Fair Usage" : "Limited Number"}</label>
          <input id={number} type="number" min="0" max="2147483647" step="1" name={number} className="form-control"
            aria-label={`${prefix ? "Shopify" : "Website / WordPress"} ${label} ${checked ? "fair usage" : "limit"}`}
            value={formik.values[number]} onChange={formik.handleChange} onBlur={formik.handleBlur} />
          {formik.touched[number] && formik.errors[number] && <div className="error">{formik.errors[number]}</div>}
        </td>
        <td className="checkbox-input"><input type="checkbox" aria-label={`${prefix ? "Shopify" : "Website / WordPress"} ${label} unlimited`}
          checked={checked} onChange={event => formik.setFieldValue(unlimited, event.target.checked ? 1 : 0)} /></td>
      </tr>;
    })}
  </React.Fragment>)}</>;
}
